export function freezeRecursive(obj: object): void {
    Object.entries(obj).forEach((item) => {
        const key = item[0];
        const value = item[1];
        if (Object.prototype.toString.call(value) === '[object Object]') {
            Object.freeze(value);
            freezeRecursive(value);
        }
        Object.defineProperty(obj, key, {
            value,
            writable: false,
            configurable: false,
        });
    });
}